export enum DataverseActionsEnum {
  BUOverView,
  DEVOverView,
  NewDTOContract,
  CreateExportTemplate,
  CopyExportTemplate,
  EditExportTemplate,
  KeyUserView
}


export enum DataverseSubActionEnum {
  None = 1,
  ReferenceFields,
  EditField,
  Export,
  NewField,
  Delete,
  EditDto,
  ExportTemplates,
  CopyExportTemplate,
  FieldsBucket,
  PreviewChanges,
  ExportTemplatesList,
  EditTemplate,
  DeleteTemplate,
  PublishUnpublishTemplate,
  CreateExportTemplate,
  CancelExport,
  DeleteDTO
}
